import { ComponentProps } from "react";
import { styled, Text, View, ViewProps } from "tamagui";

import { Accordion } from "../../ui/accordion";
import { Card } from "../../ui/card";
import { RenderMd } from "../../ui/custom-md";

const ComposedTextTitle = styled(Text, {
  name: "ComposedTextTitle",
  fontFamily: "$subtitle",
  fontWeight: "$6",
  fontSize: "$7",
  lineHeight: "$7",
  $gtMd: {
    fontWeight: "$7",
    fontSize: "$7.3",
    lineHeight: "$7.3",
  },
});

type ContainerProps = ComponentProps<typeof Card>;

const Container: React.FC<ContainerProps> = (props) => {
  return (
    <Card
      shadow="md"
      flexDirection="row"
      borderRadius={"$9"}
      gap={"$8"}
      padding={"$6"}
      {...props}
    />
  );
};

const TextContainer: React.FC<ViewProps> = (props) => {
  return <View flex={1} width={"100%"} gap={"$3"} {...props} />;
};

const ScoreContainer: React.FC<ViewProps> = (props) => {
  return (
    <View
      flex={1}
      maxWidth={344}
      width={"100%"}
      alignItems="flex-end"
      {...props}
    />
  );
};

export const ComposedText = {
  Container,
  RenderMd,
  Title: ComposedTextTitle,
  TextContainer,
  ScoreContainer,
  Accordion,
};
